import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from './../../../core/components/base/base.component';

@Component({
  selector: 'app-ward-settings',
  templateUrl: './ward-settings.component.html',
  styleUrls: ['./ward-settings.component.scss']
})
export class WardSettingsComponent extends BaseComponent {
  // Internal wards array (sorted on input)
  private _wards: any[] = [];

  /**
   * Accept an array of existing wards, sort by name
   */
  @Input()
  set wards(val: any[]) {
    this._wards = val ? [...val].sort((a, b) => a.name.localeCompare(b.name)) : [];
  }
  get wards(): any[] {
    return this._wards;
  }

  /**
   * Emit when the wards array changes (new or removed)
   */
  @Output() wardsChange = new EventEmitter<any[]>();
  @Input() hospitalId: string = '';
  @Output() wardDeleted = new EventEmitter<string>();

  /**
   * Push new blank ward to top and notify parent
   */
  addWard() {
    const newWard = { name: '', procedureCode: '' };
    this._wards.unshift(newWard);
    this.wardsChange.emit(this._wards);
  }

  /**
   * Remove a ward and notify parent
   */
  removeWard(ward: any) {
    this._wards = this._wards.filter(w => w !== ward);
    this.wardsChange.emit(this._wards);
    if (ward.id) {
      this.wardDeleted.emit(ward.id);
    }
  }

  /**
   * Show informational dialog without propagating click
   */
  openInfoDialog(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.showInfoDialog('Auto Coding Information', [
      "Assigning a procedure code to a ward will ensure that the code is automatically applied daily to all patients in that ward.",
      "For instance, you can use code 1210 for the ICU or 0109 for General Wards.",
    ]);
  }
}
